const contentBlocks = document.getElementsByClassName('c-content');

if (contentBlocks) {
    for (let index = 0; index < contentBlocks.length; index++) {
        const element = contentBlocks[index];
        if (element.querySelectorAll('.mb-2').length > 0) {
            element.querySelectorAll('.mb-2')[element.querySelectorAll('.mb-2').length - 1].classList.remove('mb-2', 'mb-md-6');            
        }
    }
}